
import { styled } from '@mui/material/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: '12px',
    padding: theme.spacing(2),
    minWidth: '600px',
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  color: '#333',
  paddingBottom: theme.spacing(1),
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  paddingTop: theme.spacing(2) + ' !important', // Override default behavior
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2),
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  color: '#666',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  backgroundColor: '#5E8E7E',
  color: '#fff',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#4A7A6A',
  },
}));
